// extracted by mini-css-extract-plugin
export var RelatedArticles = "related-aticles-module--RelatedArticles--a68c3";
export var RelatedTitleWrapper = "related-aticles-module--RelatedTitleWrapper--8c6cf";
export var RelatedWrapper = "related-aticles-module--RelatedWrapper--b665a";
export var RelatedWrapperInner = "related-aticles-module--RelatedWrapperInner--61f38";